import { i as R, e as Z, b as B, a as E, x as f, T as y, n as u, r as b } from "./abstract-base-CzLmw6_x.js";
import { e as G } from "./class-map-DVI1Gii9.js";
import { B as W } from "./table-cell-DSuHhZzg.js";
import { B as P } from "./beacon-primitive-ChVMWFlW.js";
import { p as V } from "./lifecycle-decorators-CUsT9aHq.js";
import { b as M } from "./query-assigned-K46zQIzj.js";
function q(i, e) {
  if (i) {
    if (e && e.includes(i.localName))
      return i.id;
    if (i.parentElement)
      return i.parentElement.id;
  }
  return "";
}
const F = "headers";
function H(i, e, t, r, a, n, o) {
  var C, D, I, $, k;
  const d = e ? (k = ($ = (I = i == null ? void 0 : i.parentElement) == null ? void 0 : I.parentElement) == null ? void 0 : $.nextElementSibling) == null ? void 0 : k.children : (D = (C = i == null ? void 0 : i.parentElement) == null ? void 0 : C.nextElementSibling) == null ? void 0 : D.children, p = q(i, r);
  let g;
  if (d && p) {
    const w = Array.from(d);
    if (w && w.length && (g = w.filter((m) => {
      const T = m.getAttribute(F);
      let L;
      return m && T && T === p && (t && a && a(m), L = m), L;
    })), g)
      return o && o(g, i), n && n(g, i), g;
  }
}
var c = /* @__PURE__ */ ((i) => (i.ASCENDING = "ascending", i.DESCENDING = "descending", i))(c || {}), j = /* @__PURE__ */ ((i) => (i.NORMAL = "normal", i.GROUP = "group", i.JUMBO = "jumbo", i))(j || {});
const U = R`:host{--cell-wrapper-padding-inline-end: 0;--text-cell-padding-inline-start: var(--beacon-table-header-nth-cell-space-padding-inline-start);--text-cell-gap: 7px;font:inherit;inline-size:inherit;overflow:inherit;text-align:inherit;text-transform:inherit;word-break:initial}.hide{display:none}.table-header-wrapper{display:flex;inline-size:var(--table-override-header-wrapper-inline-size, inherit);padding-inline-end:var(--cell-wrapper-padding-inline-end)}.table-header-wrapper .text-cell{display:flex;gap:var(--text-cell-gap);inline-size:100%}.table-header-wrapper .text-cell__text{--text-cell-padding-block-start: var(--beacon-table-header-nth-cell-space-padding-block-start-normal);inline-size:inherit;padding-block-start:var(--text-cell-padding-block-start);padding-inline-start:var(--text-cell-padding-inline-start)}.table-header-wrapper .text-cell__text .title{margin:0}.table-header-wrapper .text-cell__text .subtitle{font-weight:var(--beacon-font-weight-normal);margin:0;text-transform:none}.table-header-wrapper .sort-icon{--override-icon-button-surface-size: var(--beacon-table-header-icon-size-normal);--sort-icon-padding-block-start: var(--beacon-table-header-sort-wrapper-space-padding-block-start-normal);display:var(--table-override-header-sort-icon-display, initial);padding-block-start:var(--sort-icon-padding-block-start)}.table-header-wrapper ::slotted([slot=action-zone]){--override-icon-button-surface-size: var(--beacon-table-header-icon-size-normal);--action-zone-padding-block-start: var(--beacon-table-header-action-zone-space-padding-block-start-normal);padding-block-start:var(--action-zone-padding-block-start)}.table-header-wrapper select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;background-origin:content-box;background-position:right center;background-repeat:no-repeat;border:0;cursor:inherit;inline-size:100%;overflow:hidden;padding:0;text-overflow:ellipsis;white-space:break-spaces;word-break:break-word}.table-header-wrapper select:hover{text-decoration:underline}.table-header-wrapper select option{color:var(--beacon-colors-dark-grey-3)}.table-header-wrapper .selected-value{position:absolute;text-transform:initial;visibility:hidden;white-space:nowrap}.table-header-wrapper.jumbo .title,.table-header-wrapper.jumbo .subtitle,.table-header-wrapper.jumbo select,.table-header-wrapper.jumbo .selected-value{font-size:var(--beacon-body-font-size-100);line-height:var(--beacon-body-font-line-height-module-100);text-transform:initial}.table-header-wrapper.jumbo .text-cell__text{--text-cell-padding-block-start: var(--beacon-table-header-nth-cell-space-padding-block-start-jumbo)}.table-header-wrapper.jumbo .sort-icon{--override-icon-button-surface-size: var(--beacon-table-header-icon-size-jumbo);--sort-icon-padding-block-start: var(--beacon-table-header-sort-wrapper-space-padding-block-start-jumbo)}.table-header-wrapper.jumbo ::slotted([slot=action-zone]){--override-icon-button-surface-size: var(--beacon-table-header-icon-size-jumbo);--action-zone-padding-block-start: var(--beacon-table-header-action-zone-space-padding-block-start-jumbo)}.table-header-wrapper .table-dropdown{--dropdown-padding-block-start: var(--beacon-table-header-dropdown-space-padding-block-start-normal);background-color:transparent;background-image:var(--beacon-table-header-icon-color-background);color:var(--beacon-color-hyperlink-default);cursor:pointer;display:var(--table-override-header-dropdown-display, flex);padding-block-start:var(--dropdown-padding-block-start)}.table-header-wrapper.jumbo .table-dropdown{--dropdown-padding-block-start: var(--beacon-table-header-dropdown-space-padding-block-start-jumbo)}`;
var J = Object.defineProperty, Q = Object.getOwnPropertyDescriptor, l = (i, e, t, r) => {
  for (var a = r > 1 ? void 0 : r ? Q(e, t) : e, n = i.length - 1, o; n >= 0; n--)
    (o = i[n]) && (a = (r ? o(e, t, a) : o(a)) || a);
  return r && a && J(e, t, a), a;
};
const x = "beacon-table-header", Y = ["beacon-icon-button"], z = "aria-sort", K = ".beacon-table", X = ".cell", ee = "has-dropdown", te = "headers", _ = "display: none", h = "beacon-icon-button", v = "number-of-headers", A = "selected", re = ".selected-value", O = "sorted", ae = "sort-direction", ie = "sort-inactive", N = "style", S = class S extends P(W) {
  constructor() {
    super(...arguments), this.subtitle = "", this.variant = j.NORMAL, this.dropdown = !1, this.sortable = !1, this.hasActionZone = !1, this.sortInactive = !1, this.selectedValue = "select", this.selectedWidth = 0, this.nestedHeaders = [], this.beaconTagName = x, this.compare = (e, t) => this.sortDirection === c.ASCENDING ? e.value === t.value ? 0 : typeof e.value == "number" && typeof t.value == "number" ? e.value - t.value : e.value < t.value ? -1 : 1 : this.sortDirection === c.DESCENDING ? e.value === t.value ? 0 : typeof e.value == "number" && typeof t.value == "number" ? t.value - e.value : e.value > t.value ? -1 : 1 : 0, this.getParentElementHeaders = (e) => {
      let t = "";
      return e && e.parentElement && (t = e.parentElement.getAttribute(te) || ""), t;
    }, this.getSelectedFromElements = (e) => {
      let t;
      return e && e.length && (t = (e == null ? void 0 : e.find((r) => r.hasAttribute(A))) || e[0]), t;
    }, this.processNestedHeaders = (e) => {
      var t, r;
      if (e) {
        const a = (r = (t = this.parentElement) == null ? void 0 : t.parentElement) == null ? void 0 : r.children, n = a && Array.from(a);
        let o = 0;
        n && (o = this.findStartingIndex(n, e));
        for (const [d, p] of e.entries())
          p.id && this.nestedHeaders.push({
            value: p.id,
            selected: p.hasAttribute(A),
            colId: d + o
          });
        o && this.prepStyleObj(this.nestedHeaders);
      }
    }, this.prepStyleObj = (e) => {
      const t = document.querySelector(K), r = t == null ? void 0 : t.querySelector(`${N}[${v}='${this.currentIndex}']`);
      r && (t == null || t.removeChild(r));
      const a = `{${_}}`;
      let n = "";
      for (const d of e)
        d.selected || (n = `${n + this.prepareStyleString(d.colId)},`);
      n = this.removeLastCharacter(n);
      const o = n + a;
      t && this.createStyleTag(t, o, this.currentIndex);
    }, this.createStyleTag = (e, t, r) => {
      if (e) {
        const a = document.createElement(N);
        a.innerText = `${t}`, a.setAttribute(v, r.toString()), e == null || e.appendChild(a);
      }
    }, this.setDropdownAttributes = (e) => {
      var t;
      e.setAttribute(N, _), (t = e.parentElement) == null || t.setAttribute(ee, "");
    }, this.siblingCollectionCallback = (e, t) => {
      t.subHeaderNodes = e.map((r) => r.querySelector(t.getScopedTagName(x)));
    }, this.setSelectedAttributes = (e, t) => {
      const r = t.getSelectedFromElements(e);
      r == null || r.setAttribute(A, ""), t.processNestedHeaders(e);
    };
  }
  static get styles() {
    return [super.styles, U];
  }
  postrenderTableHeaderSetup() {
    var e;
    if (this.dropdown) {
      H(
        this,
        !0,
        !0,
        void 0,
        this.setDropdownAttributes,
        this.setSelectedAttributes,
        this.siblingCollectionCallback
      );
      const t = (e = this.nestedHeaders.find((r) => r.selected)) == null ? void 0 : e.value;
      this.selectedValue = t || this.selectedValue, this.adjustSelectWidth(), this.setColSpanForDropdowns();
      return;
    }
    H(this, !0, !1, void 0, void 0, void 0, this.siblingCollectionCallback);
  }
  /** Sets a data attribute on the parent element equal to the columns it would span if it wasn't using the dropdown feature. */
  setColSpanForDropdowns() {
    var e;
    this.parentElement && ((e = this.subHeaderNodes) == null ? void 0 : e.length) > 0 && (this.parentElement.dataset.colSpan = this.subHeaderNodes.length.toString());
  }
  /**
   * Process while on column sort happens.
   */
  onSort() {
    var e;
    if (this.sortable) {
      const t = ((e = this.parentElement) == null ? void 0 : e.id) || "", r = this.getParentElementHeaders(this);
      this.sortDirection === c.ASCENDING ? this.sortDirection = c.DESCENDING : this.sortDirection = c.ASCENDING, Z(this, B.SORT, { detail: { id: t, headers: r } }), this.setSortedAttr();
    }
  }
  /**
   * Sets related ARIA_SORT attribute to the parentElement th. This being used when sort happens.
   */
  setSortedAttr() {
    var e, t;
    (e = this.parentElement) == null || e.setAttribute(z, this.sortDirection), (t = this.parentElement) == null || t.classList.add(O), this.sortInactive = !1;
  }
  /**
   * When Sorting happens on another columns this removes any sort attributes applied to parentElement th.
   * @param ele HTMLElement| Element
   */
  resetSortedAttr(e) {
    var t;
    e && (e.setAttribute(ie, "true"), e.removeAttribute(ae), e.removeAttribute(z), (t = e.parentElement) == null || t.classList.remove(O));
  }
  /**
   * Based on sortInactive returns token value.
   * @returns token value.
   */
  applySvgToken() {
    return this.sortInactive ? "var(--beacon-color-cta-text-tertiary-inactive)" : "var(--beacon-color-cta-text-tertiary-default)";
  }
  /**
   *
   * @returns TemplateResult
   */
  handleSortIcon() {
    let e;
    return this.sortable && (this.sortDirection === c.ASCENDING ? e = E`<${this.getScopedTag(h)}
          @beacon-event-click="${this.onSort}"
          id="${c.ASCENDING}"
          label="${c.ASCENDING}"
          variant="tertiary"
          class="sort-icon"
        >
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3L12 8H8.5L8.5 13H7.5L7.5 8H4L8 3Z" style="fill: ${this.applySvgToken()}" />
          </svg>
        </${this.getScopedTag(h)}>` : this.sortDirection === c.DESCENDING ? e = E`<${this.getScopedTag(h)}
          @beacon-event-click="${this.onSort}"
          id="${c.DESCENDING}"
          label="${c.DESCENDING}"
          variant="tertiary"
          class="sort-icon"
        >
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.5 8L8.5 3H7.5L7.5 8H4L8 13L12 8H8.5Z"
              style="fill: ${this.applySvgToken()}"
            />
          </svg>
        </${this.getScopedTag(h)}> ` : e = E`<${this.getScopedTag(h)}
          @beacon-event-click="${this.onSort}"
          id="sort"
          label="default-sorting"
          variant="tertiary"
          class="sort-icon"
        >
          <svg slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2L11 6H5L8 2ZM8 14L5 10H11L8 14Z" style="fill: ${this.applySvgToken()}" />
          </svg>
        </${this.getScopedTag(h)}>`), e || f``;
  }
  /**
   * Triggers when selection change happens to dropdown.
   * @param event
   */
  async handleSelectChange(e) {
    var t;
    this.selectedValue = (t = e.target) == null ? void 0 : t.value, this.resetSortedAttr(this), await this.updateComplete.then(() => (this.nestedHeaders = this.updateNestedHeaders(this.nestedHeaders, this.selectedValue), this.prepStyleObj(this.nestedHeaders), this.adjustSelectWidth()));
  }
  /**
   * It processes nestedHeaders based on provided array.
   * @param nestedHeaders TableHeaderDropdown[]
   * @param selectedValue string
   * @returns TableHeaderDropdown[]
   */
  updateNestedHeaders(e, t) {
    return e && e.forEach((r) => {
      r.selected ? r.selected = !1 : r.value === t && (r.selected = !0);
    }), e;
  }
  /**
   * While Dropdown is true, this will update correct spacing for the arrow icon and text.
   */
  async adjustSelectWidth() {
    var r, a, n;
    await this.updateComplete;
    const e = this.shadowRoot && ((r = this.shadowRoot) == null ? void 0 : r.querySelector(re)), t = this.shadowRoot && ((a = this.shadowRoot) == null ? void 0 : a.querySelector(X));
    if (e && t) {
      const o = (n = window.getComputedStyle(t)) == null ? void 0 : n.paddingLeft, d = o && parseInt(o, 10) || 0, p = e.offsetWidth;
      p < t.offsetWidth - d ? this.selectedWidth = p + 4 : this.selectedWidth = 0;
    }
  }
  /**
   * Pass collection of below elements to return from what could be the starting index for particular table-header.
   * @param parentElsArr Element[] - Collection of parentElement[]
   * @param currentEl Element[] - Collection of currentElement[]
   * @returns number
   */
  findStartingIndex(e, t) {
    this.setAttribute(v, t.length.toString()), this.currentIndex = e == null ? void 0 : e.findIndex((a) => a === this.parentElement);
    let r = 0;
    for (let a = 0; a < this.currentIndex; a += 1) {
      const n = e[a];
      if (n) {
        const o = n.firstElementChild;
        if (o && o.hasAttribute(v)) {
          const d = o.getAttribute(v);
          d && (r = parseInt(d, 10) + a);
        } else
          r = a + 1;
      }
    }
    return r;
  }
  /**
   * Provided string to be checked if it has any extra comma available at the end and it will remove it.
   * @param str string
   * @returns string
   */
  removeLastCharacter(e) {
    let t = "";
    return e && e.lastIndexOf(",") === e.length - 1 && (t = e.substring(0, e.length - 1)), t;
  }
  /**
   * Based on index will prepare string to hide column.
   * @param index number
   * @returns string
   */
  prepareStyleString(e) {
    return `td:nth-of-type(${e})`;
  }
  /**
   * Sets state variable dependent on slotted action-zone elements
   *
   * @param {Event} e
   */
  actionZoneSlotChange(e) {
    var t;
    this.hasActionZone = !!((t = this.slottedActionZone) != null && t.length);
  }
  /**
   * Action zone render method that conditionally hides padding based on `hasActionZone` state variable
   */
  renderActionZone() {
    const e = {
      "has-cell-padding": !0,
      "action-cell": !0,
      hide: !this.hasActionZone
    };
    return f`
      <div class=${G(e)}>
        <slot name="action-zone" @slotchange=${this.actionZoneSlotChange}></slot>
      </div>
    `;
  }
  render() {
    return f`<div class="table-header-wrapper ${this.variant}">
      <div class="has-cell-padding text-cell" part="text-cell">
        <div class="text-cell__text">
          <p class="title">
            <slot></slot>
          </p>
          <p class="subtitle"><slot name="subtitle">${this.subtitle}</slot></p>
          ${this.dropdown ? f`<select
                  id="select"
                  @change="${this.handleSelectChange}"
                  style="background-position: ${this.selectedWidth ? `${this.selectedWidth}px` : "left 100% top 50%"};
                width: ${this.selectedWidth ? "100%" : "calc(100% + 4px)"}"
                  name="dropdown"
                  class="table-dropdown"
                  value=${this.selectedValue}
                  aria-label="${this.selectedValue}"
                >
                  ${this.nestedHeaders ? this.nestedHeaders.map((e) => f`<option ?selected=${e.selected}>${e.value}</option>`) : y}
                </select>
                <span class="selected-value" aria-hidden="true">${this.selectedValue}</span>` : y}
        </div>
        ${this.sortable ? this.handleSortIcon() : y}
      </div>
      ${this.renderActionZone()}
    </div> `;
  }
};
S.tagName = x, S.nestedComponents = Y;
let s = S;
l([
  u({ reflect: !0, alternateSlot: "subtitle", sync: !1 })
], s.prototype, "subtitle", 2);
l([
  u({ reflect: !0 })
], s.prototype, "variant", 2);
l([
  u({ attribute: "dropdown", type: Boolean, reflect: !0 })
], s.prototype, "dropdown", 2);
l([
  u({ attribute: "sortable", type: Boolean, reflect: !0 })
], s.prototype, "sortable", 2);
l([
  b()
], s.prototype, "hasActionZone", 2);
l([
  u({ attribute: "sort-direction", reflect: !0 })
], s.prototype, "sortDirection", 2);
l([
  u({ attribute: "sort-inactive", type: Boolean, reflect: !0 })
], s.prototype, "sortInactive", 2);
l([
  M({ flatten: !0, slot: "action-zone" })
], s.prototype, "slottedActionZone", 2);
l([
  b()
], s.prototype, "selectedValue", 2);
l([
  b()
], s.prototype, "selectedWidth", 2);
l([
  b()
], s.prototype, "subHeaderNodes", 2);
l([
  b()
], s.prototype, "nestedHeaders", 2);
l([
  b()
], s.prototype, "currentIndex", 2);
l([
  V
], s.prototype, "postrenderTableHeaderSetup", 1);
export {
  s as B,
  H as f
};
